import React, { useEffect, useRef } from "react";
import WaveSurfer from "wavesurfer.js";

const Player = ({ audioFile }) => {
    const waveformRef = useRef(null); // 波形を描画する DOM 要素の参照
    const waveSurferRef = useRef(null); // WaveSurfer.js インスタンスの参照

    useEffect(() => {
        // WaveSurfer インスタンスの初期化
        waveSurferRef.current = WaveSurfer.create({
            container: waveformRef.current, // 波形を描画する DOM コンテナ
            waveColor: "grey", // 波形の色
            progressColor: "#1DA59F", // 再生中の波形の色
            cursorColor: "#1DA59F", // カーソルの色
            responsive: true, // レスポンシブ対応
            height: 60, // 波形の高さ
            xhr: {
                mode: "cors", // CORS を有効にする
                withCredentials: false, // 必要に応じて調整
            },
        });

        // オーディオファイルのロード
        waveSurferRef.current.load(audioFile);
        console.log("audioURL:", audioFile);

        return () => {
            // クリーンアップ処理で WaveSurfer インスタンスを破棄
            if (waveSurferRef.current) {
                console.log("destroyed");
                waveSurferRef.current.destroy();
                waveSurferRef.current = null;
            }
        };
    }, [audioFile]);

    // 再生/一時停止のトグル
    const handlePlayPause = () => {
        if (waveSurferRef.current) {
            waveSurferRef.current.playPause();
        }
    };


    //デバッグ用
    useEffect(() => {

        waveSurferRef.current.on('error', (e) => {
            console.error("WaveSurfer error:", e);
        });

        waveSurferRef.current.on('ready', () => {
            console.log("WaveSurfer is ready");
        });

        waveSurferRef.current.on('loading', (progress) => {
            console.log("Loading progress:", progress);
        });

    }, []);

    //ここまで

    return (
        <div className="waveform-wrapper">
            {/* 波形を描画するコンテナ */}
            <div ref={waveformRef} style={{ width: "100%", margin: "20px 0" }}></div>
            {/* 再生/一時停止ボタン */}
            <button onClick={handlePlayPause}>Play / Pause</button>
        </div>
    );
};

export default Player;
